import { render, staticRenderFns } from "./BluePrint.vue?vue&type=template&id=45fcccc2&scoped=true"
import script from "./BluePrint.vue?vue&type=script&lang=js"
export * from "./BluePrint.vue?vue&type=script&lang=js"
import style0 from "./BluePrint.vue?vue&type=style&index=0&id=45fcccc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fcccc2",
  null
  
)

export default component.exports